import DatePicker from 'vue2-datepicker';
import datepicker from '@/custom';
import moment from 'moment-timezone';
import custom from '@/custom';
import groupList from '../../../Management/group/group.List.i18n'

//restful api
import { detect as webcastle } from '@/service/api/webcastle'

import codes from '@/codes';

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv : false,
  created_at_ed : moment(),
  created_at_sd : moment().subtract(1, 'month').startOf('d'),
});

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: true, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'Date', sortable: true, thStyle: 'width: 10%' },
    { key: 'group.groupname', label : 'Group', sortable: true },
    { key: 'remote_addr', label: 'Attacker', sortable: true, thStyle: 'width: 10%' },
    { key: 'target', label: 'Victim', sortable: true, thStyle: 'width: 10%' },
    { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: 'Risk', sortable: false, thStyle: 'width: 10%' },
    { key: 'uri', label: 'URI', sortable: false },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: true, thStyle: 'width: 5%' },
    { key: 'created_at', label: '날짜', sortable: true, thStyle: 'width: 10%' },
    { key: 'group.groupname', label : '회사명', sortable: true },
    { key: 'remote_addr', label: '공격자', sortable: true, thStyle: 'width: 10%' },
    { key: 'target', label: '대상', sortable: true, thStyle: 'width: 10%' },
    { key: 'is_block', label: '응답', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: '위험도', sortable: false, thStyle: 'width: 10%' },
    { key: 'uri', label: 'URI', sortable: false },
  ]
}

export default {
  data: () => {
    return {
      chainGroup : false,
      datepicker,
      show: true,
      so : default_opt(),
      custom,
      summaryData : { enable : '', disable : '', total : '', deleted : '' },
      group_name : "",
      sync : { th : undefined, stop : false, interval : 15, enable : false },
      t : "Total:",
      b : "Block:",
      d : "Detection:",
      nbsp : "\u00A0",
      hide_del : true,
      codes,
      year_modal : false,
      date_modal : false,
      date_check : undefined
    }
  },
  components: {
    groupList,
    DatePicker,
  },
  computed: {
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    },
    fields() {
      return i18n_fields[this.i18n];
    }
  },
  methods: {
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    set_op(k, v) {
      if(["m_line", "m_id", "group_id"].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_sd'] = moment().startOf('d');
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    summary() {
      let and = [];

      //날짜 범위 오류로 +1 day 하여 백엔드로 보냄 [#5739]
      let re_created_at_ed = moment(this.so.created_at_ed).add(1, 'day').startOf('d')

      // webcastle.summaryDetect({ and : and, or : [], sort : [], start_at : this.so.created_at_sd, end_at : this.so.created_at_ed })
      webcastle.summaryDetect({ and : and, or : [], sort : [], start_at : this.so.created_at_sd, end_at : re_created_at_ed })
        .then(rs => { this.summaryData = Object.assign(this.summaryData, { enable : rs.body.enable, disable : rs.body.disable, total : rs.body.total, deleted : rs.body.deleted }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    reset() { this.so = default_opt(); this.group_name = ''; this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems: function(ctx) {
      // 시작 날짜 및 마지막 날짜 유무 판별
      if(!this.so.created_at_sd || !this.so.created_at_ed){
        this.date_modal = true;
        return this.date_modal
      }

      // 조회 기간 최대 1년
      this.date_check = this.check_date();
      if(this.date_check > 365){
        this.year_modal = true;
        return this.year_modal
      }

      return this.load(ctx); 
    },
    load(ctx = {}) {
      if(!this.view_detail !== false) {
        // not component
        this.summary();
      }
      
      let so = {
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        offset : this.so.currentPage-1 || 0,
        limit :  10,
        body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : [] },
      }
      so.offset = so.offset * so.limit;

      //날짜 범위 오류로 +1 day 하여 백엔드로 보냄 [#5739]
      let re_created_at_ed = moment(this.so.created_at_ed).add(1, 'day').startOf('d')

      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
      // if(this.so.created_at_ed) { so.body.and.push({ name : 'created_at', value : this.so.created_at_ed, op : '<='}); }
      if(this.so.created_at_ed) { so.body.and.push({ name : 'created_at', value : re_created_at_ed, op : '<='}); }
      if(this.so.created_at_sd) { so.body.and.push({ name : 'created_at', value : this.so.created_at_sd, op : '>='}); }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '='}); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_block':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'updated_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'updated_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return webcastle.listDetect(so).then(rs => {
        this.so.totalRows = rs.total;
        if(rs.total > 0){
          rs.body.forEach(r => {
            if(!r.headers) { r.reqTarget = ''; return '' }
            const headers = r.headers.split('\n');
            let reqTarget = '';
            for (let i = 0; i < headers.length; i++) {
              const line = headers[i].replace(/\s/, '').toLowerCase();
              if(line.indexOf('host') == -1) { continue;  }
              reqTarget = line.replace('host:', '');
            }
            r.reqTarget = reqTarget && reqTarget != r.target ? reqTarget : '';
          });
        }
        return rs.body;
      }).catch(e => {
        console.log(e)
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
      });
    },
    goDetail: function(item) { console.log(item); this.$router.push(`log/${item.id}`); },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    },
    //기간설정 수정
    check_date(){
      //최대 1년단위 기간 조회
      let sd = moment(this.so.created_at_sd)
      let ed = moment(this.so.created_at_ed)

      let check_date = ed.diff(sd, 'day');
      return check_date
    },
  },
  created: function() { console.log('Block-Detect.vue', 'created'); this.$root.$on('select', this.setGroup); },
  destroyed: function() { console.log('Block-Detect.vue', 'destroyed'); },
  mounted: function() {
    console.log('Block-Detect.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
  },
}